"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtraElementsInFirstArray = void 0;
/**
 * @description return an array of elements exist in first array but not in second array
 * */
function getExtraElementsInFirstArray(firstArr, secondArr) {
    return firstArr.filter((element) => !secondArr.includes(element));
}
exports.getExtraElementsInFirstArray = getExtraElementsInFirstArray;
//# sourceMappingURL=getExtraElementsInFirstArray.js.map